import React from 'react'
import { ISaleTokenList, SaleTokenList } from '../../data/SaleTokenList'
import { useActiveWeb3React } from '../../../../hooks'
import { ChainId } from '@yetiswap/sdk'
import INFTCurrencyDropdown from './INFTCurrencyDropdown'
import NFTDropdown from '../NFTDropdown'
import { DropdownItemProps } from 'semantic-ui-react'

export default function NFTCurrencyDropdown({ onChange, allOption, defaultValue }: INFTCurrencyDropdown) {
  const { chainId } = useActiveWeb3React()
  const currencyList: DropdownItemProps[] = SaleTokenList.map((item: ISaleTokenList) => {
    return {
      key: item.name,
      text: item.name,
      value: item[chainId ? chainId : ChainId.AVALANCHE],
      image: { avatar: true, src: item.image }
    }
  })

  if (allOption === true) {
    currencyList.unshift({
      key: 'ALL_NFT_PROJECTS',
      text: 'All Currencies',
      value: 'ALL'
    })
  }

  return (
    <NFTDropdown
      options={currencyList}
      onChange={onChange}
      defaultValue={defaultValue ? defaultValue : currencyList[0].value}
    />
  )
}
